import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'scss/layout.scss';

import './index.scss';

export default function FormField({label, required, children}) {
    return (
        <label className="form-field layout-stack">
            <div className={classNames('form-field__label')}>
                {label}
                {required ? <span className="form-field__required">(required)</span> : null}
            </div>
            {children}
        </label>
    );
}

FormField.propTypes = {
    label: PropTypes.string,
    required: PropTypes.bool,
    children: PropTypes.children
};



// WEBPACK FOOTER //
// ./components/form_field/index.js